module.exports = __webpack_public_path__ + "static/media/bus.4bf2d1f7.png";